import { request, config } from "./repository.js";

export function getLayout() {
    return request("get", config.authLayoutUrl);
}
